type LogLevel = 'DEBUG' | 'INFO' | 'WARN' | 'ERROR';

const LOG_LEVEL = (import.meta.env.VITE_LOG_LEVEL || 'INFO') as LogLevel;

const LEVELS: Record<LogLevel, number> = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3,
};

function shouldLog(level: LogLevel): boolean {
  return LEVELS[level] >= LEVELS[LOG_LEVEL];
}

function formatTime(): string {
  return new Date().toISOString();
}

export const logger = {
  debug: (category: string, message: string, data?: unknown) => {
    if (shouldLog('DEBUG')) {
      console.log(`[${formatTime()}] [DEBUG] [${category}] ${message}`, data ?? '');
    }
  },

  info: (category: string, message: string, data?: unknown) => {
    if (shouldLog('INFO')) {
      console.log(`[${formatTime()}] [INFO] [${category}] ${message}`, data ?? '');
    }
  },

  warn: (category: string, message: string, data?: unknown) => {
    if (shouldLog('WARN')) {
      console.warn(`[${formatTime()}] [WARN] [${category}] ${message}`, data ?? '');
    }
  },

  error: (category: string, message: string, data?: unknown) => {
    if (shouldLog('ERROR')) {
      console.error(`[${formatTime()}] [ERROR] [${category}] ${message}`, data ?? '');
    }
  },
};
